import { PlannerEnv } from '@/utils/env';
import { ReactNode, createContext, useContext, useState } from 'react';

type EnvProviderState = {
  env: PlannerEnv;
  setEnv: (env: PlannerEnv) => void;
};

const initialState: EnvProviderState = {
  env: 'cte',
  setEnv: () => {},
};

const EnvProviderContext = createContext<EnvProviderState>(initialState);

export function EnvProvider({ children }: { children: ReactNode }) {
  const [env, setEnv] = useState<PlannerEnv>('cte');

  return (
    <EnvProviderContext.Provider value={{ env, setEnv }}>
      {children}
    </EnvProviderContext.Provider>
  );
}

export const useEnv = () => {
  const context = useContext(EnvProviderContext);

  if (!context) {
    throw new Error('useEnv must be used within a EnvProvider');
  }

  return context;
};
